import { defineMessages } from 'react-intl';

export default defineMessages({
  submitButton: {
    id: 'SignupForm.buttonText',
    description: 'Create Account Button Text',
    defaultMessage: 'Create Account',
  },
  firstNameError: {
    id: 'SignupForm.firstNameErr',
    description: 'First Field Error Message',
    defaultMessage: 'Enter first name. Field cannot be blank.',
  },
  lastNameError: {
    id: 'SignupForm.lastNameErr',
    description: 'Last Name Field Error Message',
    defaultMessage: 'Enter last name. Field cannot be blank.',
  },
  phoneNumberError: {
    id: 'SignupForm.phoneNumErr',
    description: 'Phone Number Field Error Message',
    defaultMessage: 'Phone number must be 10 digits. (000) 000-0000',
  },
  emptyEmailError: {
    id: 'SignupForm.emailEmptyErr',
    description: 'Email Field Error Message',
    defaultMessage: 'Enter valid email address. Field cannot be blank.',
  },
  emailFormatError: {
    id: 'SignupForm.emailformatErr',
    description: 'Email Format Error Message',
    defaultMessage: 'Enter valid email address.',
  },
  emailExistsErrorMsg: {
    id: 'SignupForm.emailExistsErr',
    description: 'Email Exists Error Message',
    defaultMessage: 'An account with this email address already exists. Please ',
  },
  emailExistsLoginText: {
    id: 'SignupForm.emailExistsLoginText',
    description: 'Email Exists Login Link Text',
    defaultMessage: 'log in',
  },
  emailExistsOrText: {
    id: 'SignupForm.emailExistsOrText',
    description: 'Email Exists Or Text',
    defaultMessage: ' or ',
  },
  emailExistsResetText: {
    id: 'SignupForm.emailExistsResetText',
    description: 'Email Exists Reset Password Link Text',
    defaultMessage: 'reset your password.',
  },
  emailSubscriptionLabel: {
    id: 'SignupForm.emailSubscriptionLabel',
    description: 'Email Subscribe Checkbox Label',
    defaultMessage: 'Sign up for exclusive email promotions',
  },
  emailSubscribeLegalText: {
    id: 'SignupForm.emailSubscriptionLegalText',
    description: 'Email Subscribe Legal Label 1',
    defaultMessage: 'By clicking \'Sign up now\' you represent that you are at least 18 years of age and have read, understand, and agree to be bound by Purple\'s Customer Program Terms and Conditions',
  },
  emailSubscribeLegalText2: {
    id: 'SignupForm.emailSubscriptionLegalText2',
    description: 'Email Subscribe Legal Label 2',
    defaultMessage: '. To see how we may use your information, please take a look at our ',
  },
  emailSubscribeLegalLink: {
    id: 'SignupForm.emailSubscriptionLegalLink',
    description: 'Email Subscribe Legal Link',
    defaultMessage: 'located here',
  },
  emailSubscribeTermsPrivacyText: {
    id: 'SignupForm.emailTermsPrivacyText',
    description: 'Email Subscribe Legal Label 3',
    defaultMessage: 'Privacy Policy.',
  },
  passwordError: {
    id: 'SignupForm.passwordErr',
    description: 'Password Field Error Message',
    defaultMessage: 'Enter a password. Field cannot be blank.',
  },
  passwordLengthError: {
    id: 'SignupForm.passwordLengthError',
    description: 'PasswordValidation length validation text',
    defaultMessage: '10 characters minimum',
  },
  firstNameLabel: {
    id: 'SignupForm.firstNameLabel',
    description: 'First Name Label',
    defaultMessage: 'First Name',
  },
  lastNameLabel: {
    id: 'SignupForm.lastNameLabel',
    description: 'Last Name Label',
    defaultMessage: 'Last Name',
  },
  emailLabel: {
    id: 'SignupForm.emailLabel',
    description: 'Email Label',
    defaultMessage: 'Email',
  },
  phoneLabel: {
    id: 'SignupForm.phoneLabel',
    description: 'Phone Number Label',
    defaultMessage: 'Phone Number',
  },
  passwordLabel: {
    id: 'SignupForm.passwordLabel',
    description: 'Password Label',
    defaultMessage: 'Password',
  },
  emailNotVerifiedErrorTitle: {
    id: 'PasswordAccountCreation.emailNotVerifiedErrorTitle',
    description: 'verification needed title',
    defaultMessage: 'VERIFICATION NEEDED',
  },
  emailNotVerifiedError: {
    id: 'PasswordAccountCreation.emailNotVerifiedError',
    defaultMessage: 'We’ve sent a verification email to {customerEmail}. Once you’ve verified your email you’ll be able to sign in.',
  },
});
